import { action, observable } from 'mobx';

export type ToastType = 'error' | 'info';

export type IMessage = {
  key: number;
  message: string | undefined;
  type: ToastType;
  duration?: number;
};
class ToastStore {
  @observable queue: IMessage[] = [];

  @action public addMessage = ({
    message,
    type = 'info',
    duration = 7000,
  }: Partial<IMessage>) => {
    const key = new Date().getTime();
    this.queue.push({ message, key, type, duration });
  };

  @action public removeMessage = (key: number) => {
    this.queue = this.queue.filter((message) => message.key !== key);
  };
}

const toastStore = new ToastStore();

export default toastStore;
